import { Show, type ParentComponent } from "solid-js";
import { useLocation } from "@solidjs/router";
import { Motion, Presence } from "solid-motionone";

/**
 * Animated wrapper for routed pages. Keyed on the pathname so each navigation
 * re-mounts and plays an enter animation. The small delay + duration also
 * throttles rapid back-to-back taps on mobile (prevents jarring fast switches).
 */
const RouteTransition: ParentComponent = (props) => {
  const location = useLocation();

  return (
    <Presence exitBeforeEnter>
      <Show when={location.pathname} keyed>
        <Motion.div
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -6 }}
          transition={{ duration: 0.28, delay: 0.04, easing: "ease-out" }}
        >
          {props.children}
        </Motion.div>
      </Show>
    </Presence>
  );
};

export default RouteTransition;
